export const getWidgetInstanceId = () => {
    try {
        const url = window.location.search.substring(1);
        const qArray = url.split('&');

        for (const item of qArray) {
            const pArr = item.split('=');
            if (pArr[0] === 'token') {
                return pArr[1];
            }
        }

        throwErrorForToken();

        return '';
    } catch {
        throwErrorForToken();

        return '';
    }
};

const throwErrorForToken = () => {
    // eslint-disable-next-line no-console
    console.error('Widget instance id is not provided');
};
